export default __webpack_public_path__ + "static/media/1892.9080e6f6.png";